import { useAuth } from "../auth/AuthContext";
import {
  isSchedulingIncluded,
  PLAN_UPGRADE_URL,
} from "../utils/planCapabilities";

const REPORT_RANK = { NONE: 0, SIMPLE: 1, COMPLETE: 2, ADVANCED: 3 };
const SUPPORT_RANK = { TICKET: 1, CHAT: 2, DEDICATED: 3 };
const AI_RANK = { NONE: 0, BASIC: 1, ADVANCED: 2, CUSTOM: 3 };

export function usePlanFeature(feature) {
  const { user } = useAuth();
  const plan = user?.tenant?.plan;

  const upgradeUrl = PLAN_UPGRADE_URL;

  // ⚠️ ASSIMETRIA DELIBERADA — não "padronize" este case para `!!plan.x`.
  //
  // Todos os demais gates deste hook FECHAM por ausência (`!!plan.crmIncluded`):
  // são capacidades que só o plano pago libera, e errar para "bloqueado" custa
  // um upsell perdido. `scheduling` é o oposto: agendamento existe em TODOS os
  // planos menos um (o Plano Atendimento, ADR-0026). Errar para "bloqueado"
  // aqui significa tirar a agenda de um cliente pagante por causa de um campo
  // que não chegou no payload — o pior erro possível. Errar para "liberado"
  // custa, no máximo, uma tela que responde 403 (tratado com CTA de upgrade).
  // O porquê completo mora em `utils/planCapabilities.js`.
  //
  // Resolvido ANTES do guard `if (!plan)` justamente porque esse guard nega por
  // omissão — passar por ele inverteria o fail-safe durante a hidratação do
  // AuthContext.
  if (feature === "scheduling") {
    return { allowed: isSchedulingIncluded(plan), upgradeUrl };
  }

  if (!plan) return { allowed: false, upgradeUrl };

  switch (feature) {
    case "leads": {
      const limit = plan.leadsLimit ?? 0;
      return { allowed: limit > 0, limit, upgradeUrl };
    }
    case "members": {
      const limit = plan.membersLimit ?? 0;
      return { allowed: limit > 0, limit, upgradeUrl };
    }
    case "ai":
      return { allowed: !!plan.aiIncluded, upgradeUrl };
    case "crm":
      return { allowed: !!plan.crmIncluded, upgradeUrl };
    case "ai_advanced":
      return { allowed: !!plan.aiIncluded && AI_RANK[plan.aiType] >= AI_RANK.ADVANCED, upgradeUrl };
    case "ai_custom":
      return { allowed: plan.aiType === "CUSTOM", upgradeUrl };
    case "support":
      return { allowed: SUPPORT_RANK[plan.supportType] >= 1, tier: plan.supportType, upgradeUrl };
    case "support_chat":
      return { allowed: SUPPORT_RANK[plan.supportType] >= 2, upgradeUrl };
    case "support_dedicated":
      return { allowed: plan.supportType === "DEDICATED", upgradeUrl };
    case "reports":
      return { allowed: REPORT_RANK[plan.reportsType] >= 1, tier: plan.reportsType, upgradeUrl };
    default:
      return { allowed: false, upgradeUrl };
  }
}
